import styled from "styled-components";
import UploadIcon from "@mui/icons-material/Upload";
import { theme } from "../../../../../helpers/theme";
import { IconButton} from "@mui/material";
import { useEffect, useState } from "react";
import { addWarehousesImage } from "../../../../../services/warehouses-images/add-image";
import { useMutation } from "@tanstack/react-query";
import { WarehousesGallery } from "../../../../../services/warehouses/get-all/types";
import { getAllWarehouses } from "../../../../../services/warehouses/get-all";
import {
  imageType,
} from "../../helpers";
import { toast } from "react-toastify";
import { settings } from "../../../../../helpers/toast.settings";
import { AllertMessage } from "../allert-message";

export type VerifyImageLoading = {
  img: File;
  message: string;
  type: string;
};

interface AddImageProps {
  MagazynId: string;
  isGalleryChange: boolean;
  setIsGalleryLoading: (value: boolean) => void;
  setIsGalleryChange: (value: boolean) => void;
  setImagesList: (imagesList: WarehousesGallery[]) => void;
}

export const AddImage = ({
  MagazynId,
  setIsGalleryLoading,
  setImagesList,
}: AddImageProps) => {
  const [errorImigeMessage, setErrorImigeMessage] =
    useState<VerifyImageLoading | null>(null);
  const [errorMessage, setErrorMessage] = useState<string[]>([]);
  const getAllWarehousesMutation = useMutation(getAllWarehouses, {
    onSuccess: (res) => {
      setImagesList(res.data.payload.magazyny[0].zdjecia_magazynu);
      setIsGalleryLoading(false);
    },
  });
  const addWarehousesImageMutation = useMutation(addWarehousesImage, {
    onSuccess: (res) => {
      setIsGalleryLoading(true);
      getAllWarehousesMutation.mutate({
        paginacja: null,
        filtr: {
          id_magazyn: MagazynId,
        },
      });
    },
    onError: (err: any) => {
      if (err.response.data.errors_debug[0] === "Internal expectation failed") {
        toast.error("Próba załadowania pliku nie powiodła się", {
          toastId: "Internal expectation failed",
          ...settings,
        });
      }
    },
  });

  useEffect(() => {
     setErrorMessage([])
  }, []);

  const handlePreUploadImage = (files:FileList): void => {
    let errorMessage: string[] = [];
    if (files !== null) {
      Array.from(files).forEach((file) => {
        if (!imageType.includes(file.type)) {
          errorMessage.push(
            `Plik:${file.name}  - nie został rozpoznany jako plik graficzny`
          );
        }
        if (file.size >= 5242880) {
          errorMessage.push(`Plik ${file.name}  - jest za duży (max 5MB)`);
        }
      });
      setErrorMessage(errorMessage);
    }
  };
  const handleUploadImage = (e: React.ChangeEvent<HTMLInputElement>): void => {
    let files = e.target.files;

    if (files !== null) {
      handlePreUploadImage(files)
      Array.from(files).forEach((file) => {
        return imageType.includes(file.type) && file.size < 5242880
          ? addWarehousesImageMutation.mutate({
              MagazynId: MagazynId,
              Zdjecia: file,
            })
          : null;
      });
    } else {
    }
  };

  return (
    <>
      <IconButton
        color="primary"
        aria-label="upload file"
        component="label"
        sx={{
          color: `${theme.colors.black_primaryText}`,
        }}
      >
        {" "}
        <ImageUploadLabel>Wczytaj obraz/obrazy</ImageUploadLabel>
        <input
          multiple
          name="files[]"
          hidden
          accept="image/*"
          type="file"
          style={{ marginTop: "-10px" }}
          onChange={handleUploadImage}
        />
        <UploadIcon />
      </IconButton>
      {errorMessage.length > 0 ? (
        <AllertMessage message={errorMessage} />
      ) : null}
    </>
  );
};

const ImageUploadLabel = styled.div`
  padding: 5px 10px;
  font-family: Inter Regular;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  overflow-wrap: break-word;
`;
